import { useState } from 'react';
import { AccountDocumentSummary } from 'vopay';
import vopayApi from '@/services/api.config';

const { api } = vopayApi;

/**
 * The documents stored against one account. Both routes authenticate as the account itself, so the
 * caller passes that account's bearer — the same token the Agreement and Signers tabs use.
 */
export default function useAccountDocuments() {
  const [fetching, setFetching] = useState(false);
  const [documents, setDocuments] = useState<AccountDocumentSummary[]>();

  async function fetchAccountDocuments(documentType: string, bearer: string) {
    try {
      setFetching(true);

      const res = await api.fetchDocuments({ DocumentType: documentType }, bearer);

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      setDocuments(res.Documents);

      return res.Documents;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  /** The list carries no URL; reading one is a second call, so it is made when the link is used. */
  async function fetchDocumentUrl(documentId: string, bearer: string) {
    try {
      const res = await api.fetchDocument({ DocumentID: documentId }, bearer);

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      return res.Document;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  return { documents, fetching, fetchAccountDocuments, fetchDocumentUrl };
}
